import ax from "../../shared/utils/http_client"

export const CartBrand = () => ({
  items: [],

  init() {
    this.items = JSON.parse(this.$el.dataset.items);

    this.$root.addEventListener("cart-item-changed", () => {
      this.recalculateBrandState()
    })
  },

  get show() {
    // 根據購物車實際狀態決定是否顯示該品牌區塊
    const cart = this.$store.frontend.cart
    if (!cart || !cart.items) return false

    const brandSlug = this.$el.dataset.brandId
    const brandItems = cart.items.filter((item) => item.brand === brandSlug && item.quantity > 0)

    return brandItems.length > 0
  },

  get brandAllSelected() {
    const cart = this.$store.frontend.cart
    if (!cart || !cart.items) return false
    const brandSlug = this.$el.dataset.brandId
    const brandItems = cart.items.filter(item => item.brand === brandSlug)

    // 只篩選非 draft 商品
    const availableItems = brandItems.filter(item => item.product?.state === "published")

    if (availableItems.length === 0) return false

    return availableItems.every(item => item.selected)
  },

  get isDisabled() {
    const brandSlug = this.$el.dataset.brandId

    // 如果這個品牌有任何已選中的商品，則不禁用
    const cart = this.$store.frontend.cart
    if (!cart || !cart.items) return false

    const brandItems = cart.items.filter((item) => item.brand === brandSlug)
    const hasSelectedItems = brandItems.some((item) => item.selected)

    if (hasSelectedItems) return false

    // 檢查是否可以選擇這個品牌
    return !this.$store.frontend.canSelectBrand(brandSlug)
  },

  async toggleBrand(event) {
    const brandSlug = this.$el.dataset.brandId
    const selected = event.target.checked

    this.updateBrandUI(brandSlug, selected)

    try {
      const { data } = await ax.patch(`/api/v1/cart/toggle_brand_items`, {
        brand_slug: brandSlug,
        selected: selected,
      })
      this.$store.frontend.setCart(data.cart)
      this.items = data.cart.items.map((item) => item.slug)

      this.notifySelectAllUpdate()
    } catch (error) {
      this.rollbackBrandItems(brandSlug, selected)
      if (error.response && error.response.data && error.response.data.error) {
        alert(error.response.data.error)
        event.target.checked = !selected
        // 如果有購物車資料，更新它
        if (error.response.data.cart) {
          this.$store.frontend.setCart(error.response.data.cart)
        }
      } else {
        console.error("Failed to toggle brand:", error)
        event.target.checked = !selected
      }
    }
  },

  remove() {
    if (confirm("確定刪除？")) {
      let itemIds = [...this.items];

      this.updateCartItem(itemIds)
    }
  },

  async updateCartItem(itemIds) {
    let result;
    for (const id of itemIds) {
      result = await ax.patch('/api/v1/cart/update_item', {
        id: id,
        quantity: 0
      })
    }
    this.$store.frontend.setCart(result.data.cart)

    this.notifySelectAllUpdate()
  },

  notifySelectAllUpdate() {
    this.$dispatch("cart-item-changed")
  },

  updateBrandUI(brandSlug, selected) {
    const brandCheckbox = document.querySelector(`[data-brand-id="${brandSlug}"].store-checkbox`)
    if (brandCheckbox) {
      brandCheckbox.checked = selected
    }

    const itemCheckboxes = document.querySelectorAll(`[data-brand-id="${brandSlug}"].item-checkbox`)
    itemCheckboxes.forEach((checkbox) => {
      checkbox.checked = selected
    })

    // 通知其他組件狀態已改變
    this.$dispatch("cart-item-changed")
  },

  //API 請求失敗時，將checkbox恢復到操作前的未勾選狀態
  rollbackBrandItems(brandSlug, failedSelected) {
    this.updateBrandUI(brandSlug, !failedSelected)
  },

  recalculateBrandState() {
    const brandSlug = this.$el.dataset.brandId
    const brandCheckbox = document.querySelector(`[data-brand-id="${brandSlug}"].store-checkbox`)
    const itemCheckboxes = document.querySelectorAll(`[data-brand-id="${brandSlug}"].item-checkbox`)

    if (!brandCheckbox || itemCheckboxes.length === 0) return

    const allChecked = Array.from(itemCheckboxes).every((checkbox) => checkbox.checked)
    brandCheckbox.checked = allChecked
  },

})
